// @ts-nocheck
import React from 'react';
import { pddTestApi } from './../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';
export default ({
  filter = {},
  ...selectProps
}) => <AutocompleteSelect fetch={async params => {
  return await pddTestApi.fetch({
    ...filter,
    ...params
  });
}} refetchParams={{
  filter
}} fetchSingle={pddTestApi.get} notFoundText="Тест не найден" placeholder="Выберите тест" renderOption={(pddTest, Option) => <Option key={pddTest.id} value={pddTest.id} pddTest={pddTest}>
        {pddTest.name}
      </Option>} {...selectProps} />;
